import { getIsFocusedInboxEnabled } from 'owa-session-store';
import type { MailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';

// Gets if Focused Inbox feature is enabled for the user
export function isFocusedInboxEnabled(mailboxInfo: MailboxInfo): boolean {
    // Unified Inbox does not support Focused Inbox because offline does not support "other" folder
    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        return false;
    }

    return !!getIsFocusedInboxEnabled(mailboxInfo);
}
